import { StyleSheet, View, Text, TouchableOpacity,Image} from 'react-native';

import colors from '../../constants/colors';


const TableInfo = ({ data,tour,levelTime,showITM}) => {
  //copy to clipboard


  return (
    <View style={styles.container}>

          {/* Short Deck 6+ */}
       {data?.gameType == "TEXAS_HOLDEM_SIX_PLUS" ? (
        <Text style={styles.tableType}>
           6+
         
       
        </Text>

        
      ) : null}

      {data?.tournamentId!=null?
      <View style={styles.mttCon}>
        <View style={styles.mttTxt}>
        <Image resizeMode='contain' style={{width:"100%",height:"100%"}} source={require("../../assets/inGameAssets/TableInfoMtt.png")}/>
        </View>
        <View style={styles.mttImg}>
        <Image resizeMode='contain' style={{width:"100%",height:"100%"}}  source={require("../../assets/inGameAssets/pokerhotMTT.png")}/>
        </View>
        </View>
      :null}
      {/* ID and COPY Clipboard */}
      <TouchableOpacity
        activeOpacity={1}
        style={styles.row}
        onPress={() => {
       
        }}
      >


        <Text style={styles.tableIdTxt}>
          Table ID:#{data?.id} {'\t'}
        </Text>
      
      </TouchableOpacity>

    
      {/* NAME */}
      <Text style={styles.tableIdTxt}>{data?.name} {tour?.isFinalTableIdFinal?.toString() == data?.id?.toString()?"Final Table":""}</Text>
      {/* Blinds */}
      {data?.gameType!="TEXAS_HOLDEM_SIX_PLUS"?
      <Text style={styles.tableIdTxt}>
        Blinds: {data?.tournamentId!=null ? tour?.blindDetails?.blinds : data?.realTimeResultsData?.blinds}
      </Text>:null}

      {data?.tournamentId!=null?
      <Text style={styles.tableIdTxt}>
        { tour?.levelExp ==null? `${String(tour?.levelsDuration ?? 0).padStart(2, '0')}:00` : (levelTime!="0" && levelTime!="00:00") ? levelTime: `${String(tour?.levelsDuration ?? 0).padStart(2, '0')}:00`}   Next Level: {tour?.nextLevel?.blinds}
      </Text>:null}
      
      {/* Straddle */}
      {data?.isStraddle ? (
        <Text style={styles.tableIdTxt}>
          Voluntary Straddle(
          {data?.straddleType == 'BUTTON' ? 'Button' : ''}
          {data?.straddleType == 'UTG' ? 'First-to-act-player' : ''}
          {data?.straddleType == 'EVERYONE' ? 'Everyone' : ''})
        </Text>
      ) : null}

      {/* RIT */}
       {data?.isRit ? (
        <Text style={styles.tableIdTxt}>
       
          {data?.ritType == 'PLAYERSCHOICE' ? 'Run It Multi-Times' : ''}
          {data?.ritType == 'TWOTIMES' ? 'Mandatory Run It Twice' : ''}
          {data?.ritType == 'THREETIMES' ? 'Mandatory Run It 3 times' : ''}
        </Text>
      ) : null}

       {/* Bombpot */}
      {data?.isBombPot ? (
        data?.board.length==0 || data?.bombValue==0?
         data?.bombPotType == "HANDS"?
       <Text style={styles.tableIdTxt}>
  {
    data?.handCount === 1 || data?.handCount ==0
      ? `Bomb Pot: Every ${data?.bombPotMinFrequency} hands (${data?.bombPotMinAnte * data?.bigBlind}-${data?.bombPotMaxAnte * data?.bigBlind})`
      : (() => {
          const remaining =
            data?.bombPotMinFrequency -
            (
              (data?.handCount - 1) %
              data?.bombPotMinFrequency
            );

          return `Bomb Pot: After ${remaining} ${
            remaining === 1 ? 'hand' : 'hands'
          } (${data?.bombPotMinAnte * data?.bigBlind}-${data?.bombPotMaxAnte * data?.bigBlind})`;
        })()
  }
</Text>:
        <Text style={styles.tableIdTxt}>
          Bomb Pot: Every {data?.bombPotMinFrequency}-{data?.bombPotMaxFrequency} minutes ({data?.bombPotMinAnte*data?.bigBlind}-{data?.bombPotMaxAnte*data?.bigBlind})
          
        </Text>
        
        :
         <Text style={styles.tableIdTxt}>
          Bomb Pot: ({data?.bombValue})
          
        </Text>

      ) : null}

       {/* Sushi */}
       {data?.isSushi ? (
        <Text style={styles.tableIdTxt}>
          {data?.initAnte? `Initial Ante: ${data?.initAnte * data?.bigBlind}` : ''}
          {"\t"}
          {data?.SBAnte? `Small Blind Ante: ${data?.SBAnte * data?.bigBlind}` : ''}
       
        </Text>

        
      ) : null}
   

        {/* Squid */}
       {data?.isSquid ? (
        <Text style={styles.tableIdTxt}>
        {data?.squidType? `${data.squidType.charAt(0).toUpperCase() + data.squidType.slice(1).toLowerCase()} Squid` : ''}
          {"\t"}
          {data?.squidValue? `Squid value: ${!data?.withoutBlinds? data?.squidValue * data?.bigBlind: data?.squidValue * data?.ante}` : ''}
       
        </Text>

        
      ) : null}

        {/* Insurance */}
       {data?.isInsurance ? (
        <Text style={styles.tableIdTxt}>
        Insurance
       
        </Text>

        
      ) : null}
      

       {/* Short Deck 6+ */}
       {data?.gameType == "TEXAS_HOLDEM_SIX_PLUS" ? (
        <Text style={styles.tableIdTxt}>
          {data?.ante? ` Ante: ${data?.ante}` : ''}
         
       
        </Text>

     

        
      ) : null}

        
        {showITM?
          <View style={styles.itmCon}>
          <Image resizeMode='contain' style={{width:"100%",height:"100%"}} source={require('../../assets/inGameAssets/ITMLogo.png')}/>
          </View>:null
        }
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    width: '100%',
    alignItems: 'center',
  },
  row: {
    flexDirection: 'row',
    alignItems:"center",
    justifyContent: 'center',
  },
  tableIdTxt: {
    color: colors.white,
    fontSize: 9,
    textAlign:"center",
    fontFamily: 'AvertaStd-Regular',
  },
   tableType: {
   color: colors.gray,
  fontSize: 11,
  textAlign: "center",
  fontFamily: 'AvertaStd-Bold',

  // 👇 Light shadow effect
  textShadowColor: 'rgba(0, 0, 0, 0.25)', // light soft shadow
  textShadowOffset: { width: 0.5, height: 0.5 },
  textShadowRadius: 1,
  },
  itmCon:{
    width:60,
    height:30,
    //backgroundColor:"red"
  },
  mttCon:{
    flexDirection:'row',
    justifyContent:"center",
    alignItems:"center",
    width:100,
    height:40,position:"absolute",top:-40
  },
  mttTxt:{
    width:60,
    height:20,
   
  },
  mttImg:{
    width:30,
    height:20,
    
    

  }
});
export default TableInfo;
